import React from 'react';
import { Typography, TypographyProps, SxProps, Box } from '@mui/material';

interface CopyrightProps extends TypographyProps {
  sx?: SxProps; // Aceita sx como prop opcional
}

const Copyright: React.FC<CopyrightProps> = ({ sx, ...props }) => {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        position: 'fixed',
        bottom: 0,
        py: 2,
        bgcolor: 'background.default',
        display: 'flex',
        justifyContent: 'center', // Centraliza horizontalmente
        alignItems: 'center',    // Centraliza verticalmente
        textAlign: 'center',
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: '10px', ...sx }} // Margem superior e estilos adicionais
        {...props}
      >
        {'Direitos Reservados © '}
        <a href="https://backupfacil.com" style={{ textDecoration: 'none', color: 'inherit' }}>
          Backup Fácil
        </a>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </Box>
  );
};

export default Copyright;